export default __webpack_public_path__ + "static/object-larger-do-598df60435e5fce5d7aea0c9e503dc3f.png";